/* ica-inspection.js — FAQ accordion behavior for the Inspection Services page.

   Q1 opens by default (server-rendered with aria-expanded="true" on the
   button + .is-open on the wrapper); clicks toggle each item.

   T1 #9 A1: aria-expanded lives ONLY on the interactive button — required
   for axe-core / Lighthouse a11y. The wrapper uses the `.is-open` state class
   so existing CSS rules (icon rotate, answer reveal) stay class-driven.

   Vanilla JS, no jQuery. Idempotent — guarded against double-binding.
*/
(function () {
  'use strict';

  function init() {
    var lists = document.querySelectorAll('[data-ica-insp-faq]');
    if (!lists.length) return;

    lists.forEach(function (list) {
      if (list.dataset.icaInspFaqBound === '1') return;
      list.dataset.icaInspFaqBound = '1';

      list.querySelectorAll('.ica-insp-faq-item').forEach(function (item) {
        var btn = item.querySelector('.ica-insp-faq-q');
        if (!btn) return;

        function toggle() {
          var open = btn.getAttribute('aria-expanded') === 'true';
          var next = open ? 'false' : 'true';
          btn.setAttribute('aria-expanded', next);
          item.classList.toggle('is-open', next === 'true');
        }

        btn.addEventListener('click', function () {
          toggle();
        });

        btn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
